import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import Amplify, { Auth } from 'aws-amplify';
import { from, of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { map, catchError } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class AmplifyService {
	constructor() {
		Amplify.configure({
			Auth: {
				region: environment.cognito.region,
				userPoolId: environment.cognito.UserPoolId,
				userPoolWebClientId: environment.cognito.ClientId
				// storage
			}
		});
	}

	/**
	 * Validar erros
	 * https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_InitiateAuth.html#API_InitiateAuth_Errors
	 */
	login(username: string, password: string): Observable<unknown> {
		return from(Auth.signIn(username, password));
	}

	isAuthenticated(): Observable<boolean> {
		return from(Auth.currentAuthenticatedUser()).pipe(
			map(user => !!user),
			catchError(err => of(false))
		);
	}

	logout(): Observable<void> {
		return from(Auth.signOut());
	}

	getJwt(): Observable<string | null> {
		return from(Auth.currentSession()).pipe(
			map(response => {
				if (response.isValid()) {
					return response.getAccessToken().getJwtToken();
				}
				return null;
			})
		);
	}
}
